module.exports = __webpack_public_path__ + "static/media/plus-circle-32x32.6e79dd6c.svg";